export var numberWithDotsAndComma = function (num) {
    var number = typeof num === 'string' ? Number(num) : num;
    var parts = number.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',');
};
